import { DataInputsHighlightBarProps } from './index';
import { DynamicPageProps } from 'types/DynamicPageProps';
import { SelectInputItemProps } from 'types/SelectInputItemProps';

export function verifyIfFormCanSave(
	dataForm: DataInputsHighlightBarProps,
	setCanSaveModuleOnBack: React.Dispatch<React.SetStateAction<boolean>>,
	setMessageErrorForm: React.Dispatch<React.SetStateAction<string>>
) {
	if (dataForm.text === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Título"');
		return;
	}

	setCanSaveModuleOnBack(true);
}

export function returListOptionsDynamicPage(
	listPages: DynamicPageProps[]
): SelectInputItemProps[] {
	const listOptions: SelectInputItemProps[] = [];

	listPages.forEach((item) => {
		listOptions.push({ id: item.id, option: item.name });
	});

	return listOptions;
}
